import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState, mapGetters } from 'vuex';
import multiSearchAlarmLogs from '../../../mixins/multiSearchAlarmLogs';
import listOptionsPersistenceMixin from '../../custom/listOptionsPersistenceMixin';
import iconsMixin from '../../core/dtwin/state/bridge/iconsMixin';
import { userItemsPerListMixin, localizeDate } from '@/utils/vuex';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
var defaultItemsPerPage = 10;
var FETCH_DEBOUNCE_MS = 300;
var defaultTableOptions = {
  sortBy: ['timestamp'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreAlarmLogsList',
  mixins: [listOptionsPersistenceMixin, iconsMixin, userItemsPerListMixin, multiSearchAlarmLogs],
  props: {
    accounts: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    predefinedSearch: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    // if used in the device-type list, do not restore the last filter from the virtual-device-list
    // should show ALL unfiltered devices by default
    restoreFilter: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },
    containerClass: {
      type: String,
      default: function _default() {
        return 'n20-mainrow';
      },
      required: false
    },
    initOperator: {
      type: String,
      default: 'AND',
      required: false
    },
    staticSearchItems: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    }
  },
  data: function data() {
    return {
      commentDialogIsOpen: false,
      commentText: '',
      expanded: [],
      disableFetchOnCreatedMixin: true,
      lastSearch: null,
      searchItems: [],
      searchOperator: 'AND',
      listPersistencePath: 'AlarmLogs.list',
      searchMode: 'multi',
      isFetching: true,
      tableOptions: _objectSpread({}, defaultTableOptions),
      defaultTableOptions: _objectSpread({}, defaultTableOptions),
      selected: [],
      list: [],
      serverItemsLength: -1,
      searchItem: null,
      selectedRows: [],
      cancelTokenSource: null,
      searchPersistKey: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language'])), mapGetters({
    getAccountById: 'app/getAccountById'
  })), {}, {
    isEmptyList: function isEmptyList() {
      return this.searchItems.length === 0 && // if no search is active
      this.list.length === 0 && // if no items are in the list
      this.serverItemsLength <= 0 && // if total of items is 0
      this.isFetching === false // if the list is not being right now
      ;
    },
    canComment: function canComment() {
      return this.selectedRows.length > 0;
    },
    tableHeaders: function tableHeaders() {
      var _this = this;

      return [{
        text: this.$t('AlarmLogs.table.headers.status'),
        value: 'isResolved',
        sortable: true,
        width: '50px'
      }, {
        text: this.$t('AlarmLogs.table.headers.level'),
        value: 'logType',
        sortable: true,
        width: '50px'
      }, {
        text: this.$t('Common.id'),
        value: 'id',
        sortable: true
      }, {
        text: this.$t('AlarmLogs.table.headers.date'),
        value: 'timestamp',
        sortable: true
      }, {
        text: this.$t('AlarmLogs.table.headers.logCategory'),
        value: 'logCategory',
        sortable: true
      }, {
        text: this.$t('AlarmLogs.table.headers.message'),
        value: 'message',
        sortable: true
      }, {
        text: this.$t('AlarmLogs.table.headers.account'),
        value: 'tenantId',
        sortable: true
      }, {
        text: this.$t('AlarmLogs.table.headers.originEntity'),
        value: 'virtualDevice.title',
        sortable: false // hide: 'mdAndDown',

      }, {
        text: this.$t('AlarmLogs.table.headers.operationalStatus'),
        value: 'virtualDevice.operationalStatus',
        sortable: true
      }].filter(function (item) {
        return !item.hide || !_this.$vuetify.breakpoint[item.hide];
      });
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$t('Common.rowsPerPage'),
        itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50, 100, 200]
      };
    },
    operationalStatus: function operationalStatus() {
      return {
        0: this.$t('NiotaClassic.Devices.form.unset'),
        1: this.$t('NiotaClassic.Devices.form.inTransit'),
        2: this.$t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$t('NiotaClassic.Devices.form.inOperation'),
        4: this.$t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$t('NiotaClassic.Devices.form.decommissioned')
      };
    }
  }),
  watch: {
    initOperator: {
      handler: function handler(val) {
        this.searchOperator = val;
      }
    },
    accounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList(true);
    }, 500)
  },
  created: function created() {
    this.searchPersistKey = this.$route.path;

    var _ref = JSON.parse(localStorage.getItem(this.searchPersistKey)) || {},
        search = _ref.search;

    this.searchItems = search || [];
    this.searchOperator = this.initOperator;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  mounted: function mounted() {
    this.getMultiFilterData();
  },
  methods: {
    get: get,
    localizeDate: localizeDate,
    getMsg: function getMsg(message) {
      if (message === 'ALARM_LOG_METRIC_RESOLVED') {
        return this.$i18n_t('AlarmLogs.resolvedMessage');
      }

      return message;
    },
    closeCommentDialog: function closeCommentDialog() {
      this.commentDialogIsOpen = false;
    },
    saveComment: function saveComment() {
      var _this2 = this;

      var logIds = this.selectedRows.map(function (row) {
        return row.id;
      }).filter(function (id) {
        return id;
      });

      if (logIds.length === 0) {
        return;
      }

      var comments = logIds.map(function (logId) {
        return {
          parentLogId: logId,
          message: _this2.commentText
        };
      });
      ApiService.createAlarmLogsCommentsBatch(comments).catch(function () {
        _this2.$snack(_this2.$t('AlarmLogs.snacks.commentFailed'), 'error');
      }).finally(function () {
        _this2.fetchList();

        _this2.commentText = '';

        _this2.closeCommentDialog();
      });
    },
    transformSearchPayloadForApi: function transformSearchPayloadForApi(searchItems) {
      var KEYS_ARRAY = ['tags', 'virtualDeviceGroups'];
      var KEYS_NUMBER = ['logId', 'virtualDeviceId', 'virtualDeviceOperationalStatus'];
      var transformed = searchItems.reduce(function (acc, _ref2) {
        var variable = _ref2.variable,
            search = _ref2.search;
        // equalize search value
        var searchValue = search.value || search; // consolidate to array and/or parse number to int

        if (KEYS_ARRAY.includes(variable)) {
          acc[variable] = acc[variable] || [];
          acc[variable].push(searchValue);
        } else {
          acc[variable] = KEYS_NUMBER.includes(variable) ? parseInt(searchValue, 10) : searchValue;
        }

        return acc;
      }, {}); // restructuring result to array of objects

      return Object.entries(transformed).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            variable = _ref4[0],
            search = _ref4[1];

        return {
          variable: variable,
          search: search
        };
      });
    },
    sanitizeOrderBy: function sanitizeOrderBy(orderBy) {
      // order keys for the API are sometimes different than the table header keys
      switch (orderBy) {
        case 'id':
          return 'logId';

        case 'virtualDevice.operationalStatus':
          return 'virtualDeviceOperationalStatus';

        default:
          return orderBy || 'timestamp';
      }
    },
    fetchList: debounce(function () {
      var _this3 = this;

      this.isFetching = true;
      this.list = []; // clear list while loading

      var searchItems = (this.predefinedSearch || []).concat(this.searchItems).map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });

      if (this.accounts.length > 0) {
        searchItems.push({
          variable: 'tenantIds',
          search: this.accounts
        });
      }

      var sanitizedSearch = [].concat(_toConsumableArray(this.transformSearchPayloadForApi(searchItems)), _toConsumableArray(this.staticSearchItems));
      var _this$tableOptions = this.tableOptions,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc;
      var sortOrder = {
        variable: this.sanitizeOrderBy(sortBy[0]),
        direction: sortDesc[0] ? 'DESC' : 'ASC'
      };
      ApiService.fetchAlarmLogs(this, page, itemsPerPage, sanitizedSearch, sortOrder).then(function (response) {
        _this3.list = response.logs;
        _this3.serverItemsLength = response.pagination.total;
      }).catch(function () {
        _this3.$snack(_this3.$t('AlarmLogs.snacks.fetchLogsFailed'), 'error');
      }).finally(function () {
        _this3.isFetching = false;
      });
    }, FETCH_DEBOUNCE_MS),
    setSelected: function setSelected(rows) {
      this.selectedRows = rows;
    },
    searchUpdated: function searchUpdated(search, searchOperator) {
      var storeSearch = JSON.stringify({
        search: search,
        searchOperator: searchOperator
      });
      localStorage.setItem(this.searchPersistKey, storeSearch);
      this.searchItems = search;
      this.searchOperator = searchOperator;
      this.tableOptions.page = 1; // reset page when search changes

      this.fetchList();
    },
    getTenantNameById: function getTenantNameById(tenantId) {
      var account = this.getAccountById(tenantId);
      return account ? account.name : tenantId;
    }
  }
};